import { render, staticRenderFns } from "./page-banner.component.vue?vue&type=template&id=f0aa123c&"
import script from "./page-banner.component.vue?vue&type=script&lang=ts&"
export * from "./page-banner.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports